
































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { ApiRequest, AddLocationRequest, UpdateLocationRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { TransporterLoc } from '../../types/entity';
declare var google: any;

@Component({
    mixins: [validationMixin],
    data() {
        return {
            branchName: '',
            phone: '',
            email: '',
            address: {
                fullAddress: '',
                locality: '',
                state: '',
                city: '',
                zip: '',
            },
        };
    },
    validations: {
        branchName: {
            required,
            regex: (fullName) => /^[a-zA-Z ]+$/.test(fullName),
        },
        phone: {
            required,
            minLength: minLength(10),
            regex: (phone) =>
                /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone),
        },
        email: {
            required,
            email,
        },
        address: {
            fullAddress: {
                required,
            },
            locality: {},
            state: {
                required,
            },
            city: {
                required,
            },
            zip: {
                required,
            },
        },
    },
})
export default class UpdateLocationModal extends Vue {
    private locationGoogleAddress: any;
    private show = false;

    public mounted() {
        this.getGoogleAddress();
        this.getLocation();
    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.locationGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('locationAddress'), {
                types: ['geocode'],
            },
            );
            this.locationGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(this.locationGoogleAddress);
            });
        });
    }


    /**
     * @author <Shraddha.K>
     * @description API - Returns Transporter locations
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - list of locations
     * @returns List of transporter lists
     * @throws InvalidRequestException if transporter id is invalid
     */
    private getLocation() {
        const iHttpService = ObjectFactory.getHttpService();
        const locationId = this.$route.params.id;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/location/${locationId}`,
            loaderEvent: {
                show: true,
            },
        };
        iHttpService.get<TransporterLoc>(apiRequest).then((response) => {
            if (response.success && response.data) {
                this.$data.branchName = response.data.branchName;
                this.$data.phone = response.data.phone;
                this.$data.email = response.data.email;
                this.$data.address = response.data.locationAddress;
                this.show = true;
            } else {
                CommonUtils.showError(response);
            }
        });
    }

    /**
     * @author <shraddha.K>
     * @description - update location
     * @param req {Request} - calls update location API
     * @param res {Response} - Express Response - success result
     * @returns location list
     * @throws InvalidRequestException if location not found already exists
     */
    private async updateLocation() {
        const iHttpService = ObjectFactory.getHttpService();
        const locationId = this.$route.params.id;
        const updateLocationRequest: UpdateLocationRequest = {
            branchName: this.$data.branchName,
            phone: this.$data.phone,
            email: this.$data.email,
            locationAddress: this.$data.address,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/location/${locationId}`,
            data: updateLocationRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<UpdateLocationRequest>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_UPDATE_LOCATION'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$router.push({
            name: MedTransGoConstants.VIEW_SETTING_NAME,
        });
    }
}
